<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <h2 class="titulo-modal" style="padding-left: 16px">
        Atenção
      </h2>
    </v-card-title>

    <div>
      <v-card-text flex>
        <v-card class="pa-0" style="background: none" flat>
          <v-card-text tex class="text-xs-center">
            <h3 style="color: #555555; font-weight: 500; font-size: 16px; font-family:'Roboto Medium', 'Roboto Regular', 'Roboto', sans-serif;">
              Recusa por Restrição Cadastral.
            </h3>
            <h3 v-if="mostrarMensagemCompleta" style="color: #555555; font-weight: 500; font-size: 16px; font-family:'Roboto Medium', 'Roboto Regular', 'Roboto', sans-serif;">
              Para esclarecimentos, por favor, entre em contato diretamente com a seguradora.
            </h3>
          </v-card-text>
        </v-card>

        <v-card-actions class="pb-4">
          <v-layout row>
            <v-flex xs12 md4F class="justify-content-center">
              <v-btn style="font-weight: 500" class="button-custom" flat @click="fecharDialogModalRestricaoTecnica()">
                ENTENDI
              </v-btn>
            </v-flex>
          </v-layout>
          
        </v-card-actions>
      </v-card-text>
    </div>
  </v-card>
</template>
<script>
  export default {
    name: "ModalRestricaoTecnica",
    props: {
      mostrarMensagemCompleta: Boolean,
    },
    methods: {
      fecharDialogModalRestricaoTecnica() {
        this.$emit("fecharDialogModalRestricaoTecnica");
      },
    }
  };
</script>

<style>
  .dialog {
    background: #eaeaea !important;
  }

  .titulo-modal {
    color: #fff;
    font-size: 25px !important;
    font-weight: 400;
  }

  .click {
    cursor: pointer;
  }

  .justify-content-center {
    display: flex !important;
    justify-content: center !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalRestricaoTecnica.vue